import TagsAndAttributes from "./tags";

// https://developer.mozilla.org/en-US/docs/Web/MathML/Element

const DefaultAttributes = [
  'class', 'id', 'style',
  'displaystyle', 'href', 'mathbackground', 'mathcolor',
]

const MathMLScheme: TagsAndAttributes = {
  'math': ['xmlns', 'class', 'id', 'style', 'dir', 'href',
    'mathbackground', 'mathcolor', 'display', 'mode'],
  'maction': DefaultAttributes.concat(
    ['actiontype',  'selection']
  ),
  'maligngroup': DefaultAttributes,
  'malignmark': DefaultAttributes,
  'menclose': DefaultAttributes.concat([
    'notation'
  ]),
  'merror': DefaultAttributes,
  'mfenced': DefaultAttributes.concat([
    'open', 'separators'
  ]),
  'mfrac': DefaultAttributes.concat([
    'bevelled', 'denomalign', 'linethickness', 'numalign'
  ]),
  'mi': DefaultAttributes.concat([
    'dir', 'mathsize', 'mathvariant',
  ]),
  'mlongdiv': DefaultAttributes,
  'mmultiscripts': DefaultAttributes.concat([
    'subscriptshift ', 'superscriptshift ',
  ]),
  'mn': DefaultAttributes.concat([
    'dir ', 'mathsize', 'mathvariant',
  ]),
  'mo': DefaultAttributes.concat([
    'dir ', 'accent', 'fence', 'lspace', 'mathsize', 'mathvariant',
    'maxsize', 'minsize', 'movablelimits', 'rspace',
    'separator', 'stretchy', 'symmetric'
  ]),
  'mover': DefaultAttributes.concat([
    'accent', 'align'
  ]),
  'mpadded': DefaultAttributes.concat([
    'depth', 'height', 'lspace', 'voffset', 'width'
  ]),
  'mphantom': DefaultAttributes,
  'mroot': DefaultAttributes,
  'mrow': DefaultAttributes.concat([
    'dir'
  ]),
  'ms': DefaultAttributes.concat([
    'lquote', 'mathsize', 'mathvariant', 'rquote'
  ]),
  'mscarries': DefaultAttributes,
  'mscarry': DefaultAttributes,
  'msgroup': DefaultAttributes,
  'msline': DefaultAttributes,
  'mspace': DefaultAttributes.concat([
    'depth', 'height', 'width',
  ]),
  'msqrt': DefaultAttributes,
  'msrow': DefaultAttributes,
  'mstack': DefaultAttributes,
  'mstyle': DefaultAttributes.concat([
    'dir', 'infixlinebreakstyle', 'scriptlevel', 'scriptminsize',
    'scriptsizemultiplier'
  ]),
  'msub': DefaultAttributes.concat([
    'subscriptshift'
  ]),
  'msup': DefaultAttributes.concat([
    'superscriptshift'
  ]),
  'msubsup': DefaultAttributes.concat([
    'subscriptshift', 'superscriptshift'
  ]),
  'mtable': DefaultAttributes.concat([
    'align', 'columnalign', 'columnlines', 'columnspacing',
    'frame', 'framespacing', 'rowalign', 'rowlines',
    'rowspacing', 'width'
  ]),
  'mtd': DefaultAttributes.concat([
    'columnalign', 'columnspan',
    'rowalign', 'rowspan'
  ]),
  'mtext': DefaultAttributes.concat([
    'dir', 'mathsize', 'mathvariant'
  ]),
  'mtr': DefaultAttributes.concat([
    'columnalign', 'rowalign',
  ]),
  'munder': DefaultAttributes.concat([
    'accentunder', 'align',
  ]),
  'munderover': DefaultAttributes.concat([
    'accent', 'accentunder', 'align',
  ]),
  'semantics': [],
  'annotation': [
    'definitionURL', 'displaystyle', 'encoding',
    'cd', 'name', 'src',
  ],
  'annotation-xml': [
    'definitionURL', 'displaystyle', 'encoding',
    'cd', 'name', 'src',
  ],
}

export default MathMLScheme;